import React from 'react';

export const FooterCell = ({ cell: { label, Component, align } }) => {
  return (
    <td className="custom-table__footer-cell" align={align || 'left'}>
      {Component ? Component : label}
    </td>
  );
};
